import { CurrencyPipe } from '@angular/common';
import {
  afterNextRender,
  Component,
  ElementRef,
  input,
  OnDestroy,
  output,
  viewChild,
} from '@angular/core';

@Component({
  selector: 'app-subscription-payment-confirm-modal',
  standalone: true,
  imports: [CurrencyPipe],
  templateUrl: './subscription-payment-confirm-modal.component.html',
  styles: `
    dialog.subscription-payment-dialog {
      margin: 0;
      max-width: none;
      max-height: none;
      width: 100vw;
      height: 100vh;
      border: 0;
      padding: 1rem;
      background: transparent;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    dialog.subscription-payment-dialog::backdrop {
      background: rgba(15, 23, 42, 0.6);
    }
  `,
})
export class SubscriptionPaymentConfirmModalComponent implements OnDestroy {
  readonly title = input.required<string>();
  readonly description = input('');
  readonly baseAmount = input.required<number>();
  readonly gstRate = input.required<number>();
  readonly gstAmount = input.required<number>();
  /** Total payable amount including GST. */
  readonly amount = input.required<number>();
  readonly billingLabel = input('');
  readonly processing = input(false);

  readonly proceed = output<void>();
  readonly cancel = output<void>();

  private readonly paymentDialog =
    viewChild<ElementRef<HTMLDialogElement>>('paymentDialog');

  constructor() {
    afterNextRender(() => {
      const dialog = this.paymentDialog()?.nativeElement;
      if (!dialog || dialog.open) {
        return;
      }
      try {
        dialog.showModal();
      } catch {
        dialog.setAttribute('open', '');
      }
    });
  }

  onDialogCancel(event: Event): void {
    event.preventDefault();
    if (!this.processing()) {
      this.cancel.emit();
    }
  }

  ngOnDestroy(): void {
    const dialog = this.paymentDialog()?.nativeElement;
    if (dialog?.open) {
      dialog.close();
    }
  }
}
